import { TaskGroupsView } from "@anydo/interfaces";

//#region Implementation
export const USER_SESSION_STORAGE_PREFIX = "anydo.user-session-storage:";
//#endregion

//#region localStorage - Auth
/**
 * NOTE: ClientId exists even after session created / removed (AKA, user login / logout)
 */
export const AUTH_CLIENT_ID_LS_KEY = "clientId";
export const AUTH_TOKEN_LS_KEY = "auth";
export const AUTH_LAST_USED_OPTION_LS_KEY = "auth.option.last-used";
export const ABSERVICE_CLIENT_ID_LS_KEY = "xAbService.clientId";
//#endregion

//#region localStorage - User search constants
export const USER_SEARCH_LS_KEY = "anydo.web-4.recentSearches.1";
//#endregion

//#region sessionStorage
export const DOCUMENT_REFERRER_ORIGIN_AND_PATHNAME_SS_KEY = "anydo.web-4.document-referrer-origin-and-pathname";
export const DOCUMENT_REFERRER_QUERY_PARAMS_SS_KEY = "anydo.web-4.document-referrer-query-params";
export const GET_PREMIUM_SS_KEY = "anydo.web-4.get-premium";
//#endregion

//#endregion

//#region ElectronStorage - (Shared with `localStorage`)
export const ELECTRON_PREFERENCES_NEW_TASK_HOTKEY_LS = "anydo.electron:new-task-hotkey";
export const ELECTRON_PREFERENCES_NEW_TASK_HOTKEY_TOGGLE_LS = "anydo.electron:new-task-hotkey-toggle";
export const ELECTRON_STARTUP_MODE_LS = "anydo.electron:startup-mode";
//#endregion

//#region UserSessionStorage - tasks views
export const TASK_GROUPS_ALL_TASKS_FILTER_USS_KEY = "task.groups-filter:all-tasks";
export const TASK_GROUPS_MYDAY_FILTER_USS_KEY = "task.groups-filter:today";
export const TASK_GROUPS_CATEGORY_FILTER_USS_KEY_PREFIX = "task.groups-filter:category:";
export const TASK_GROUPS_LABEL_FILTER_USS_KEY_PREFIX = "task.groups-filter:label:";

export const TASK_GROUPS_VIEW_USS_KEY = "task.groups-view";
export const TASK_GROUPS_VIEW_USS_KEY_DEFAULT: TaskGroupsView = TaskGroupsView.SINGLE_COLUMN;
//#endregion

//#region User settings
export const USER_SETTINGS_NOTIFICATION_ENABLED_USS = "user-settings:notification-enabled";
/** @deprecated Still needs to be used for first paint, but exclude one place it's not should be used */
export const USER_SETTINGS_THEME_USS = "user-settings:theme";
//#endregion

//#region Smart type suggestions
export const SMART_TYPE_SUGGESTION_VISIBILITY_COUNTER_USS = "smart-type:suggestion-visibility-counter-uss";
export const SMART_TYPE_SUGGESTION_VISIBILITY_SESSION_USS = "smart-type:suggestion-visibility-session-uss";
//#endregion

//#region App header product update last id
export const APP_HEADER_PRODUCT_UPDATE_LAST_ID_LS = "app-header-product-update:last-update-id-ls";
//#endregion

//#region Toggle min/max mode of card tags
export const CARD_TAGS_MAX_MODE_ENABLED_USS = "card-tags-max-mode-enabled-uss";
//#endregion

export const DISABLE_INTERCOM_USS_KEY = "disable-intercom-uss";

export const PAYMENT_APPROVE_PAYMENT_DISMISSED_USS_KEY = (spaceId: string) =>
  `payment.approve-payment.dismissed.${spaceId}`;

export const SW_LOCALE_KEY = "service-worker:i18n-locale";
